

import Rating from '~/components/svgs/how-it-works/Rating.vue';
import Shelves from '~/components/svgs/how-it-works/Shelves.vue';
import Truck from '~/components/svgs/how-it-works/Truck.vue';
import GetQuoteModal from '~/components/modal/GetQuoteModal';

export default {
  components: {
    Rating,
    Shelves,
    Truck,
    GetQuoteModal
  },
  data() {
    return {
      displayThumb: true,
      isModalVisible: false
    };
  },
  head() {
    return {
      title: 'Get Transport Quotes | UTransport',
      meta: [
          {
            hid: 'description',
            name: 'description',
            content:'Do you need a transport quote? Contact reliable truck drivers today through our platform for free! Find the right fit for your transportation needs. Get started now.'
          }
      ]
    };
  },
  methods: {
    playVideo() {
      this.displayThumb = false;
      const vid = document.getElementById('index-hero-video');
      vid.play();
    },
    redirectToBecomeACarrier(){
      this.$router.push({
        path: '/become-a-carrier'
      });
    },
    showQuoteModal() {
      this.isModalVisible = true
    },
    closeQuoteModal() {
      this.isModalVisible = false;
    }
  },
};
